module.exports = require("./contextMenu.js");


//////////////////
// WEBPACK FOOTER
// angular-bootstrap-contextmenu (bower component)
// module id = 420
// module chunks = 0